import React from 'react'
import { Outlet } from 'react-router-dom'

const MainInvoicesProjectOutgoing = () => {
  return (
    <div className='w-full h-full'>
        <Outlet/>
    </div>
  )
}

export default MainInvoicesProjectOutgoing